import { AutogenModelDistanceAlert, AutogenRowDistanceAlert } from "./autogen/AutogenModelDistanceAlert";

export class ModelDistanceAlert extends AutogenModelDistanceAlert<RowDistanceAlert> {
	constructor() {
		super(RowDistanceAlert);
	}
}

export class RowDistanceAlert extends AutogenRowDistanceAlert {
}
